module.exports = __webpack_public_path__ + "24a4b85f700b20844a8443b496245fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/end/assets/save.png
// module id = 732
// module chunks = 0